import { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";

const STEPS = [
  ["queued", "Preparing your profile"],
  ["analyzing", "Analyzing your profile"],
  ["mapping_nutrition", "Mapping your nutrition"],
  ["building_training", "Building your training plan"],
  ["finalizing", "Optimizing recovery & finalizing"],
  ["complete", "Your CG Labz program is ready"],
];

export const Generation = ({ accessId, onReady }) => {
  const [status, setStatus] = useState("queued");
  const [progress, setProgress] = useState(5);
  const timer = useRef();

  useEffect(() => {
    const poll = async () => {
      try {
        const { data } = await api.get(`/programs/${accessId}`);
        const gs = data.access.generation_status || "queued";
        setStatus(gs);
        setProgress(data.access.generation_progress || 10);
        if (data.access.status === "ACTIVE" || gs === "complete") {
          clearInterval(timer.current);
          setTimeout(onReady, 800);
        }
      } catch { /* keep polling */ }
    };
    poll();
    timer.current = setInterval(poll, 2500);
    return () => clearInterval(timer.current);
  }, [accessId, onReady]);

  const curIdx = Math.max(0, STEPS.findIndex((s) => s[0] === status));

  return (
    <div className="pt-40 pb-24 px-6 max-w-lg mx-auto min-h-screen bg-[#04060b] text-center" data-testid="program-generation">
      <div className="mono-label mb-3">Creating your CG Labz program</div>
      <div className="relative w-28 h-28 mx-auto my-6">
        <div className="absolute inset-0 rounded-full border-2 border-cyan-400/20" />
        <div className="absolute inset-0 rounded-full border-t-2 border-cyan-400 animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center font-mono text-cyan-300">{progress}%</div>
      </div>
      <div className="space-y-2 text-left max-w-xs mx-auto">
        {STEPS.slice(0, 5).map(([k, label], i) => (
          <div key={k} className={`flex items-center gap-3 text-sm transition-colors ${i <= curIdx ? "text-white" : "text-slate-600"}`} data-testid={`gen-step-${k}`}>
            <span className={`w-2 h-2 rounded-full ${i < curIdx ? "bg-cyan-400" : i === curIdx ? "bg-cyan-400 animate-pulse" : "bg-white/20"}`} />
            {label}{i === curIdx && "…"}
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-8">Chris Goss and the CG Labz Performance Team are personalizing every week around your goals, schedule and preferences.</p>
    </div>
  );
};
